import React, { useState } from 'react';
import State from '../State';

export const CompressionModeContext = React.createContext();

const CompressionModeContextProvider = props => {
	const [compressionMode, setCompressionMode] = useState(State.compressionModes.Good);
	return (
		<CompressionModeContext.Provider
			value={{ mode: compressionMode,
				update: mode => {
					setCompressionMode(mode);
				}
			}}
		>
			{props.children}
		</CompressionModeContext.Provider>
	);
};

export default CompressionModeContextProvider;



// WEBPACK FOOTER //
// ./src/context/CompressionModeContextProvider.js